import { useSelector } from 'react-redux';
import { ThemePublicSelectors } from 'reactApp/modules/themePublic/themePublic.selectors';
import type { RootState } from 'reactApp/store';

export function usePublicThemeId(public_id: string) {
    return useSelector((state) => ThemePublicSelectors.getPublicThemeId(state as RootState, public_id));
}
